/** Bare (getLayout = page) and auth-gated by the Worker guard + BetterAuthGuard, as on Vercel. */
import { createFileRoute } from '@tanstack/react-router'

import { OAuthConsentRoute } from '@/features/auth/pages/oauth-consent-client'

export const Route = createFileRoute('/_bare/oauth/consent')({ component: OAuthConsentRoute })
